import React, { ReactNode } from "react"
import { Box, Stack } from "@chakra-ui/react"
import { PassBuilderDescription } from "./PassBuilderTypography"
import {
  PassBuilderFieldHeading,
  PlatformHint,
  PlatformStatus,
} from "./PassBuilderLayout"
import { FIELD_BLOCK_DESCRIPTION_MB, FIELD_CONTROL_STACK_SPACING } from "./passBuilderTokens"

type Props = {
  title: string
  description: ReactNode
  platform?: PlatformHint
  status?: PlatformStatus
  appleStatus?: PlatformStatus
  googleStatus?: PlatformStatus
  rightElement?: ReactNode
  children?: ReactNode
}

const PassBuilderFieldBlock = ({
  title,
  description,
  platform = "both",
  status,
  appleStatus,
  googleStatus,
  rightElement,
  children,
}: Props) => (
  <Box>
    <PassBuilderFieldHeading
      title={title}
      platform={platform}
      status={status}
      appleStatus={appleStatus}
      googleStatus={googleStatus}
      rightElement={rightElement}
    />
    <PassBuilderDescription mb={children ? FIELD_BLOCK_DESCRIPTION_MB : 0}>
      {description}
    </PassBuilderDescription>
    <Stack spacing={FIELD_CONTROL_STACK_SPACING}>{children}</Stack>
  </Box>
)

export default PassBuilderFieldBlock
